import { useEffect } from 'react';
import { FlattenInterpolation, ThemeProps } from 'styled-components';
import {
  useModelForm,
  FormInput,
  SelectInput,
  ThemeType,
  UpdateType,
  SelectInputFieldProps,
} from '../../../../..';

export type ModelSelectPropsType = Omit<SelectInputFieldProps, 'value' | 'onChange' | 'id'> & {
  id?: string,
  field: string,
  valueOverride?: string,
  errorOverride?: string,
  touchOverride?: boolean,
  mutateValue?: (newValue: string) => any,
  onVisibleChange?: (visible: boolean) => void,
  containerCss?: FlattenInterpolation<ThemeProps<ThemeType>> | string,
  updateOverride?: UpdateType,
}

export function ModelSelect({
  id = '',
  field,
  valueOverride,
  errorOverride = '',
  touchOverride = false,
  mutateValue = (newValue) => newValue,
  onVisibleChange,
  containerCss,
  updateOverride,
  ...props
}: ModelSelectPropsType) {
  const {
    visible, errors, value, update, warnings,
  } = useModelForm(field, valueOverride, errorOverride, updateOverride);

  useEffect(() => {
    onVisibleChange?.(visible);
  }, [visible]);

  return (
    <FormInput visible={visible} css={containerCss} id={id}>
      <SelectInput
        {...props}
        id={`${id}-${field}`}
        value={value}
        onChange={(newValue: string) => update({ [field]: mutateValue(newValue) })}
        touchOverride={touchOverride}
        visible={visible}
        errors={errors}
        warnings={warnings}
      />
    </FormInput>
  );
}
